import { render } from "./recent-orders.vue?vue&type=template&id=5f8236f6&scoped=true"
import script from "./recent-orders.vue?vue&type=script&lang=js"
export * from "./recent-orders.vue?vue&type=script&lang=js"

import "./recent-orders.vue?vue&type=style&index=0&id=5f8236f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8236f6"]])

export default __exports__